import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Consent from "./Consent";
import PersonalInformation from "./PersonalInformation";
import {
	addressInformationVerifier,
	authorizationVerifier,
	consentVerifier,
	idVerifier,
	personalInformationVerifier,
	previousOffencesVerifier,
	selfieVerifier,
} from "../../utils/verifier";
import AddressInformation from "./AddressInformation";
import PreviousOffences from "./PreviousOffences";
import PicturesUpload from "./PicturesUpload";
import Review from "./Review";
import Authorization from "./Authorization";
import Payment from "./Payment";
import { Backdrop, CircularProgress, LinearProgress } from "@mui/material";
import IdUpload from "./IdUpload";
import IdUpload2 from "./IdUpload2";
import "./formStyle.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { API, getScreeningId } from "../../utils/http";

export default function RecordForm() {
	const token = useSelector((state) => state.auth.currentAuthenticatedUser?.nirvToken);
	const loading = useSelector((state) => state.user.status === "loading");
	const [source, setSource] = React.useState(null);
	const [activeStep, setActiveStep] = React.useState(0);
	const [skipped, setSkipped] = React.useState(new Set());
	const prefilled = useSelector((state) => state.user.prefilled);
	const applicationId = useSelector((state) => state.user.application.personalInformation).id;

	const { t } = useTranslation();

	console.log("Screening Id on Personal Info page?: ", getScreeningId());

	React.useEffect(() => {
		if (token) {
			API.get(`token/${token}`)
				.then((r) => {
					const res = r.data.payload?.student;
					if (!res) return;
					console.log(res);
					setSource(res.source);
				})
				.catch((e) => {});
		}
	}, [token]);
	const isStepSkipped = (step) => {
		return skipped.has(step);
	};
	React.useEffect(() => {
		if (prefilled) setActiveStep(1);
	}, [prefilled]);
	const handleNext = () => {
		let newSkipped = skipped;
		if (isStepSkipped(activeStep)) {
			newSkipped = new Set(newSkipped.values());
			newSkipped.delete(activeStep);
		}

		setActiveStep((prevActiveStep) => prevActiveStep + 1);
		setSkipped(newSkipped);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleReset = () => {
		setActiveStep(0);
	};
	const renderStepperControls = (handleNext, handleBack, hideNext = false, prefilled = false) => {
		return (
			<Box sx={{ display: "flex", justifyContent: hideNext ? "center" : "space-evenly", flexDirection: "row", pt: 2, mt: 4, mb: 4 }}>
				<Button
					size="large"
					color="secondary"
					variant={"contained"}
					style={{ padding: "10px 35px", borderRadius: "8px" }}
					disabled={activeStep === 0 || prefilled === true}
					onClick={handleBack}
					sx={{ mr: 1, textTransform: "none" }}
				>
					{t("Previous")}
				</Button>
				<Button
					size="large"
					onClick={() => {
						if (activeStep === steps.length - 1) {
							alert("handle non paying finish");
							//TODO: avem un alt endpoint precum /process-coupon care primeste id-ul application-ului pentru a fi marcat ca si platit.
							API.post(`/mark-as-paid`, { applicationId: applicationId })
								.then((res) => {
									console.log(res);
									window.location.href = origin + "/payment-status?coupon_message=succeeded";
								})
								.catch((err) => {
									console.log(err);
									window.location.href = origin + "/payment-status?coupon_message=failed";
								});
						} else {
							handleNext();
						}
					}}
					style={{ padding: "10px 35px", borderRadius: "8px" }}
					variant="contained"
					sx={{ textTransform: "none", display: hideNext ? "none" : "initial" }}
					color="primary"
				>
					{activeStep === steps.length - 1 ? "Finish" : t("Next")}
				</Button>
			</Box>
		);
	};
	const steps = [
		{
			label: t("Consent"),
			component: (
				<Consent prefilled={prefilled} verifier={consentVerifier} renderControls={renderStepperControls} handleNext={handleNext} handleBack={handleBack} />
			),
		},
		{
			label: t("Personal Information"),
			component: (
				<PersonalInformation
					prefilled={prefilled}
					verifier={personalInformationVerifier}
					renderControls={renderStepperControls}
					handleNext={handleNext}
					handleBack={handleBack}
				/>
			),
		},
		{
			label: t("Address Information"),
			component: (
				<AddressInformation
					prefilled={prefilled}
					verifier={addressInformationVerifier}
					renderControls={renderStepperControls}
					handleNext={handleNext}
					handleBack={handleBack}
				/>
			),
		},
		{
			label: t("Previous Offences"),
			component: (
				<PreviousOffences
					prefilled={prefilled}
					verifier={previousOffencesVerifier}
					renderControls={renderStepperControls}
					handleNext={handleNext}
					handleBack={handleBack}
				/>
			),
		},
		{
			label: t("Upload First ID"),
			component: (
				<IdUpload prefilled={prefilled} verifier={idVerifier} renderControls={renderStepperControls} handleNext={handleNext} handleBack={handleBack} />
			),
		},
		{
			label: t("Upload Second ID"),
			component: (
				<IdUpload2 prefilled={prefilled} verifier={idVerifier} renderControls={renderStepperControls} handleNext={handleNext} handleBack={handleBack} />
			),
		},
		{
			label: t("Picture Upload"),
			component: (
				<PicturesUpload
					prefilled={prefilled}
					verifier={selfieVerifier}
					renderControls={renderStepperControls}
					handleNext={handleNext}
					handleBack={handleBack}
				/>
			),
		},
		{
			label: t("Review"),
			component: (
				<Review
					prefilled={prefilled}
					verifier={personalInformationVerifier}
					renderControls={renderStepperControls}
					handleNext={handleNext}
					handleBack={handleBack}
				/>
			),
		},
		{
			label: t("Authorization and Consent"),
			component: (
				<Authorization
					prefilled={prefilled}
					verifier={authorizationVerifier}
					renderControls={renderStepperControls}
					handleNext={handleNext}
					handleBack={handleBack}
				/>
			),
		},
		{
			label: t("Payment"),
			component: (
				<Payment
					prefilled={prefilled}
					verifier={personalInformationVerifier}
					renderControls={renderStepperControls}
					handleNext={handleNext}
					handleBack={handleBack}
				/>
			),
		},
	].filter((step) => {
		//if the current email is null, skip the last step
		if (source && source.match("sehc.*.nirvsystem.com") && step.label === t("Payment")) return false;
		return true;
	});
	return (
		<Box>
			<LinearProgress
				variant="determinate"
				value={(activeStep * 100) / steps.length}
				style={{ marginBottom: "20px", position: "absolute", top: "101px", left: "0", width: "100%" }}
			/>
			{activeStep === steps.length ? (
				<React.Fragment>
					<Typography sx={{ mt: 2, mb: 1 }}>All steps completed - you&apos;re finished</Typography>
					<Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
						<Box sx={{ flex: "1 1 auto" }} />
						<Button onClick={handleReset}>Reset</Button>
					</Box>
				</React.Fragment>
			) : (
				<div>
					<Backdrop open={loading} onClick={() => {}} sx={{ zIndex: 1000 }}>
						<CircularProgress color="inherit" />
					</Backdrop>

					<Typography
						variant="h4"
						color={"primary"}
						style={{
							marginBottom: "20px",
							textAlign: "center",
							padding: "25px",
							borderRadius: "10px",
							backgroundColor: "#eff7f9",
							fontWeight: "bold",
						}}
					>
						{steps[activeStep].label}
					</Typography>
					<div className="formContainer">{steps[activeStep].component}</div>
				</div>
			)}
		</Box>
	);
}
